<template>
  <section class="connections-page">
    <div class="d-inline-flex tabBorder">
      <div
        class="tab"
        v-for="(tab, i) of tabs"
        v-bind:key="i"
        :class="{ activeTab: activeTab === tab }"
        @click="activeTab = tab"
      >
        {{ tab.label }}
      </div>
    </div>
    <div class="connections-page_tabView">
      <component
        v-for="tab in tabs"
        :key="tab.label"
        v-show="isActive(tab)"
        :is="tab.component"
      />
    </div>
    <coming-soon-modal />
  </section>
</template>

<script>
import ConnectionsList from "./tabs/ConnectionLists.vue";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";
export default {
  components: {
    ComingSoonModal,
    ConnectionsList,
  },
  data() {
    return {
      tabs: [
        {
          label: "API Integrations",
          component: ConnectionsList,
        },
      ],
      activeTab: null,
    };
  },
  computed: {
    isActive() {
      return (tab) => this.activeTab.label === tab.label;
    },
  },
  created() {
    this.activeTab = this.tabs[0];
  },
};
</script>

<style scoped lang="scss">
.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}
/* Tab styling */
.tab:hover {
  cursor: pointer;
}

.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}

.tab {
  position: relative;
  padding: 15px 25px;
  font-size: 16px;
}

.tab:focus-within {
  border-bottom: 2px solid #3c78ff;
}

.tab.activeTab::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  border-bottom: 2px solid #3c78ff;
}
.connections-page {
  padding: 50px;
  max-width: 1400px;
  &_tabs {
    button {
      color: #404040;
      text-align: center;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      background: none;
      border-radius: 0;
      border-bottom: 2px solid rgba(64, 64, 64, 0.25);
      transition: none;
      padding-bottom: 15px;

      &.active {
        border-bottom: 2px solid #3c78ff;
      }
    }
  }
}
</style>
